import styled, { css } from 'styled-components';

const StyledContainer = styled.div<{
	$height: number;
	$padding: string;
	$error?: boolean;
	$disabled?: boolean;
}>`
	position: relative;
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	height: ${({ $height }) => $height}px;
	padding: ${({ $padding }) => $padding};
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	${({ $error }) =>
		$error &&
		css`
			background-color: rgba(199, 30, 30, 0.25);
			border-color: rgba(199, 30, 30, 0.5);
		`}

	${({ $disabled }) =>
		$disabled &&
		css`
			pointer-events: none;
			background-color: rgba(255, 255, 255, 0.02);
			border: 1px solid rgba(255, 255, 255, 0);
		`}
`;

const StyledLabel = styled.span<{ $fontSize: number }>`
	flex-shrink: 0;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: ${({ $fontSize }) => $fontSize}px;
	color: rgba(255, 255, 255, 0.25);
	white-space: nowrap;
	user-select: none;
	pointer-events: none;
`;

const StyledInput = styled.input<{
	$fontSize: number;
	$textAlign: string;
	$placeholderOpacity: number;
}>`
	flex: 1;
	min-width: 0;
	background: transparent;
	border: none;
	outline: none;
	padding: 0;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 700;
	font-size: ${({ $fontSize }) => $fontSize}px;
	color: #ffffff;
	text-align: ${({ $textAlign }) => $textAlign};
	transition: color 0.3s ease;

	&::placeholder {
		color: rgba(
			255,
			255,
			255,
			${({ $placeholderOpacity }) => $placeholderOpacity}
		);
		font-weight: 400;
	}

	&:focus-visible {
		outline: none;
	}

	&:disabled {
		cursor: default;
	}

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		appearance: none;
	}
`;

const StyledIconSlot = styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
`;

const StyledUnit = styled.span`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	color: rgba(255, 255, 255, 0.5);
`;

export {
	StyledContainer,
	StyledIconSlot,
	StyledInput,
	StyledLabel,
	StyledUnit,
};
